import { useFrame, useThree } from '@react-three/fiber'
import React from 'react'
import type * as THREE from 'three'
import type { Reflector } from 'three/examples/jsm/objects/Reflector'

import { type ReflectorGate, getReflectorGate } from './reflector-gate'
import type { ReflectorRegistration } from './types'

export function useReflectorGate(): ReflectorGate {
  const gl = useThree((state) => state.gl)
  return getReflectorGate(gl)
}

export function useReflectorRegistration(
  reflector: Reflector,
  registration: ReflectorRegistration
): ReflectorGate {
  const gate = useReflectorGate()
  const camera = useThree((state) => state.camera)

  React.useEffect(
    () => gate.register(reflector, registration),
    [gate, reflector, registration]
  )

  useFrame((state) => {
    gate.runFrame(camera, state.clock.elapsedTime)
  })

  return gate
}

export function useExcludeFromReflections(
  ref: React.RefObject<THREE.Object3D | null>
): void {
  const gate = useReflectorGate()

  React.useEffect(() => {
    const object = ref.current
    if (!object) {
      return undefined
    }
    return gate.exclude(object)
  }, [gate, ref])
}
